import { render, staticRenderFns } from "./Accesos.vue?vue&type=template&id=1770b422&scoped=true"
import script from "./Accesos.vue?vue&type=script&lang=js"
export * from "./Accesos.vue?vue&type=script&lang=js"
import style0 from "./Accesos.vue?vue&type=style&index=0&id=1770b422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770b422",
  null
  
)

export default component.exports